import Form, { FormInstance } from 'antd/lib/form'
import { useEffect, useRef } from 'react'
import { AttributeValueType, QCAttributeValueType } from 'Types/Attribute.types'
import { TaskAttribute, TaskMode, QCAttributesData } from 'Types/Tasks.types'
import { Banner } from 'Components/common/Banner/Banner'
import { AttributesContent } from 'Components/tasks/Attributes/AtributesContent'
import { getDefaultAttributeValue, showAttribute } from 'Utils/attributes.utils'
import { isViewerMode } from 'Utils/task.utils'

export type QCAttributesBodyPropsType = {
    getValues: () => QCAttributesData | undefined
    attributes: TaskAttribute[]
    attributesOnUI: { [key: string]: 1 }
    onUpdateAttribute: (name: string, value: QCAttributeValueType) => void
    setForm: (form: FormInstance) => void
    isReadOnly: () => boolean
    mode: TaskMode
}

export const QCAttributesBody = (props: QCAttributesBodyPropsType) => {
    const [form] = Form.useForm()
    const toUpdateRef = useRef<Record<string, QCAttributeValueType>>({})

    useEffect(() => {
        props.setForm(form)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form])

    useEffect(() => {
        Object.entries(toUpdateRef.current).forEach(([name, value]) => {
            form.setFieldValue([name], value)
            props.onUpdateAttribute(name, value)
        })

        toUpdateRef.current = {}
    }, [form, props])

    return (
        <div>
            {(props.attributes ?? []).length > 0 && (
                <Banner message="Please review the QC attributes below." />
            )}
            <Form
                form={form}
                initialValues={props.attributes?.reduce(
                    (prev, curr) => {
                        prev[curr.name] =
                            props.getValues()?.[curr.name]?.data.value ??
                            getDefaultAttributeValue(curr.value_definition.value_type)
                        return prev
                    },
                    {} as Record<string, AttributeValueType>
                )}
                layout="vertical"
                name="qc-attributes-form"
            >
                {[...(props.attributes ?? [])].map((attribute: TaskAttribute) => {
                    if (
                        !showAttribute(
                            props.attributes,
                            attribute,
                            props.attributesOnUI,
                            props.getValues() ?? {},
                            toUpdateRef
                        )
                    ) {
                        delete props.attributesOnUI[attribute.name]
                        return null
                    }
                    props.attributesOnUI[attribute.name] = 1

                    return (
                        <>
                            <AttributesContent
                                key={attribute.attribute_id}
                                attribute={attribute}
                                value={
                                    props.getValues()?.[attribute.name]?.data?.value ??
                                    getDefaultAttributeValue(attribute.value_definition.value_type)
                                }
                                onUpdateAttribute={(name, value) => {
                                    if (attribute.is_value_editable) {
                                        props.onUpdateAttribute(name, value as QCAttributeValueType)
                                    }
                                }}
                                isReadOnly={() => isViewerMode(props.mode)}
                            />
                        </>
                    )
                })}
            </Form>
        </div>
    )
}
